import { render, staticRenderFns } from "./EditPaper.vue?vue&type=template&id=01f27112&scoped=true"
import script from "./EditPaper.vue?vue&type=script&lang=js"
export * from "./EditPaper.vue?vue&type=script&lang=js"
import style0 from "./EditPaper.vue?vue&type=style&index=0&id=01f27112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f27112",
  null
  
)

export default component.exports